import { Injectable } from '@angular/core';
import * as io from 'socket.io-client';
import { TokenService } from '../../shared/api/connector/shared';
import { environment } from '../../../environments/environment';

@Injectable()
export class Socket {

  public oauth: any;
  private socket: any;

  constructor(private token: TokenService) {}

  public connect(room: string, callback: any) {
    this.establishSocket(() => {
      this.socket.emit('enter', room);
      this.socket.on('message', (o: any) => callback(o));
    });
  }

  public disconnect(room: string, callback: any) {
    this.establishSocket(() => {
      this.socket.emit('leave', room);
      this.socket.removeListener('update', (o: any) => callback(o));
    });
  }

  private establishSocket(callback: Function) {
    if (!!this.socket) {
      callback.call(this);
    } else {
      this.token.get().take(1).subscribe((accessToken: string) => {
        this.socket = io(environment.socket.url, { path: environment.socket.path, transports: ['websocket'] });
        callback.call(this);
      });
    }
  }

}
